<template>
	<div class="accessories-store container-fluid">
		<rule-modal @close="setRules([])" />
		<loading v-if="!prebuildVariantHasChanged" />
		<div class="row bg-white">
			<div class="static-pages">
				<div class="static-pages-content p-t p-b-xl">
					<div class="container">
						<div class="row">
							<div class="col-xs-12">
								<subtotal-row
									class="sub-total-row--top"
									:prebuild-details="prebuildVariantInCart"
								>
									<sub-total
										:is-in-stock="isPreBuildInStock"
										:total-cart-price="totalCartPrice"
										:shipping-info="shippingInfo"
										@go-to-cart="goToCart('Top')"
									>
										Continue To Cart
									</sub-total>
								</subtotal-row>
							</div>
						</div>
						<div class="row">
							<div class="col-xs-12">
								<h1 class="title">
									Any Accessories?
								</h1>
							</div>
						</div>
						<div class="row">
							<template v-for="(accessory, type) in orderedAccessories">
								<div
									v-for="item in accessory"
									:key="item.id"
									class="col-xs-12 col-sm-6 col-md-4 col-lg-3"
								>
									<accessory-card :accessory="item" :type="type" />
								</div>
							</template>
						</div>
						<div class="row">
							<div class="col-xs-12">
								<div class="sub-total-row">
									<sub-total
										:is-in-stock="isPreBuildInStock"
										:total-cart-price="totalCartPrice"
										:shipping-info="shippingInfo"
										@go-to-cart="goToCart('Bottom')"
									>
										Continue To Cart
									</sub-total>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import prebuildCartData from "../mixins/prebuildCartData";
import AccessoryCard from "./accessory-card";
import SubtotalRow from "./sub-total-row/";
import SubTotal from "./sub-total-row/sub-total";
import RuleModal from "./rule-modal";
import { gtmTrack } from "@/util/gtm";

export default {
	name: "PrebuildAccessoriesStore",
	components: {
		AccessoryCard,
		SubtotalRow,
		SubTotal,
		RuleModal
	},
	mixins: [
		prebuildCartData
	],
	beforeRouteLeave(to, from, next) {
		if (to.name.includes("-cart")) {
			gtmTrack.cartTotal(this.totalCartPrice);

			if (this.gtmPrebuildVariables && this.gtmPrebuildVariables.pcSKU) {
				gtmTrack.cartPrebuild(this.gtmPrebuildVariables);
			}
		}
		next();
	},
	methods: {
		goToCart(buttonPosition) {
			this.trackContinueToCart(buttonPosition);
			this.$router.push({ name: "starter-cart" });
		}
	}
};
</script>

<style lang="scss" scoped>
.accessories-store {
    .title {
        color: #444259;
        font-size: 36px;
        line-height: 43px;
        text-align: center;
        text-transform: uppercase;
        margin-top: 40px;
        margin-bottom: 45px;

        @media (max-width: 768px) {
            text-align: left;
            margin-right: 20px;
            margin-top: 20px;
            margin-bottom: 25px;
        }
    }

    .sub-total-row {
        display: flex;
        border-top: 1px solid #dadde0;

        .sub-total {
            margin-left: auto;
            padding-top: 50px;

            @media (max-width: 768px) {
                padding-top: 0;
            }
        }
    }
}
</style>
